import { API_GET_DEPOSIT_PLACES, API_GET_DEPOSIT_SAMPLERS, API_PUT_DEPOSIT, API_DELETE_DEPOSIT } from "actions/deposit";
import { DEFAULT_CLIENT, V2_CLIENT } from "config/clientConstants";

export const getVersion = (action) => {
	const path = pathMapping[action];
	return {
		path: path ? path[path.currentClient] : undefined,
		currentClient: path ? path.currentClient : DEFAULT_CLIENT,
	}
}

const pathMapping = {
	[API_GET_DEPOSIT_PLACES]: {
		default: () => `/deposit/places`,
		v2: () => `/deposit/places`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_DEPOSIT_SAMPLERS]: {
		default: () => `/deposit/samplers`,
		v2: () => `/deposit/samplers`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_PUT_DEPOSIT]: {
		default: (folderId) => `/deposit/${folderId}`,
		v2: (folderId) => `/deposit/${folderId}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_DELETE_DEPOSIT]: {
		default: (folderId) => `/deposit/${folderId}`,
		v2: (folderId) => `/deposit/${folderId}`,
		currentClient: DEFAULT_CLIENT,
	},
};

export function getDepositPlaces() {
	const version = getVersion(API_GET_DEPOSIT_PLACES);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_GET_DEPOSIT_PLACES,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "GET",
			},
		},
	};
}

export function getDepositSamplers() {
	const version = getVersion(API_GET_DEPOSIT_SAMPLERS);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_GET_DEPOSIT_SAMPLERS,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "GET",
			},
		},
	};
}

export function saveDeposit(deposit, folderId) {
	const version = getVersion(API_PUT_DEPOSIT);
	const url = typeof version.path === 'function' ? version.path(folderId) : version.path;
	return {
		type: API_PUT_DEPOSIT,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "PUT",
				data: deposit,
			},
		},
	};
}

export function removeDeposit(folderId) {
	const version = getVersion(API_DELETE_DEPOSIT);
	const url = typeof version.path === 'function' ? version.path(folderId) : version.path;
	return {
		type: API_DELETE_DEPOSIT,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "DELETE",
			},
			folderId: folderId,
		},
	};
}
